import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';

export const globalSettingsProductsApplinksRoute = {
	name: ROUTE_NAMES.GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS,
	path: '/plugins/servlet/applinks/listApplicationLinks',
};
